import { FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { add } from '@purpur/library/icon/assets/add';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { AddProductPlaceholderContainer } from './AddProductPlaceholder.styles';

type Props = {
    href: string;
};

export const AddProductPlaceholder: FC<Props> = ({ href }) => {
    const { t } = useTranslations();

    return (
        <AddProductPlaceholderContainer href={href}>
            <div>
                <Icon svg={add} size="lg" />
            </div>
            <div>{t['eshop.comparison.add_product']}</div>
        </AddProductPlaceholderContainer>
    );
};
